<template>
  <div class="flex flex-col items-center justify-center min-h-[60vh] w-full">
    <div class="flex flex-col items-center gap-6 w-full max-w-md">
      <div class="flex items-center gap-2">
        <i class="ri-checkbox-circle-fill text-2xl text-[#248726]"></i>
        <h2 class="text-2xl font-semibold text-gray-900">Password Changed!</h2>
      </div>
      <p class="text-gray-700 text-base text-center">
        You can now log into all devices with your new password.
      </p>
      <button
        type="button"
        class="bg-[#7a2323] text-white text-base h-11 w-full rounded transition hover:opacity-90 max-w-sm"
        @click="proceedToLogin"
      >
        Proceed to Login
      </button>
    </div>
  </div>
</template>

<script setup>

function proceedToLogin() {
  window.location.href = "/";
}
</script>

<style scoped>
.text-white {
  color: #fff;
}
</style>
